
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const MEASUREMENT_ID = 'G-0L2Q5KSMHY';

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

type Props = {
  enabled: boolean;
};

export default function GoogleAnalytics({ enabled }: Props) {
  const location = useLocation();
  const lastPageView = useRef<string | null>(null);

  useEffect(() => {
    const w = window as unknown as Window & Record<string, unknown>;
    w[`ga-disable-${MEASUREMENT_ID}`] = !enabled;

    if (!enabled) {
      lastPageView.current = null;
      return;
    }

    if (!window.gtag) {
      window.dataLayer = window.dataLayer || [];

      window.gtag = function (...args: unknown[]) {
        window.dataLayer?.push(arguments);
      };
    }

    if (!document.querySelector('script[data-ga4="true"]')) {
      window.gtag('js', new Date());

      const script = document.createElement('script');
      script.async = true;
      script.src =
        `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
      script.dataset.ga4 = 'true';

      document.head.appendChild(script);
    }

    window.gtag('config', MEASUREMENT_ID, {
      send_page_view: false,
    });

    const path = location.pathname + location.search;

    if (lastPageView.current === path) return;

    lastPageView.current = path;

    window.gtag('event', 'page_view', {
      send_to: MEASUREMENT_ID,
      page_title: document.title,
      page_location: window.location.href,
      page_path: path,
    });
  }, [enabled, location.pathname, location.search]);

  return null;
}
